const ITEMS = [
  "DUBLIN", "CORK", "GALWAY", "LIMERICK", "WATERFORD", "KILKENNY", "NATIONWIDE INSTALLATION",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-obsidian py-6" data-testid="location-marquee">
      <div className="sfm-marquee-track">
        {row.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display text-3xl font-extrabold uppercase tracking-tight text-white/15 sm:text-4xl">
            {item}
            <span className="h-2 w-2 rotate-45 bg-amber" />
          </span>
        ))}
      </div>
    </div>
  );
};
